import * as yup from "yup";

export const connectivityExtraSchema = yup.object({
    extension: yup.string().nullable(),
    teaserMediaId: yup.string().nullable(),
    name: yup.string().required("Nome é obrigatório"),
    backgroundColor: yup.string().nullable(),

    versions: yup.array().of(
        yup.object({
            name: yup.string().required("Nome da versão é obrigatório"),
            modelCode: yup.string().required("Model code é obrigatório"),
            year: yup.string().required("Ano é obrigatório"),
            connectivity: yup.string().required("Conectividade é obrigatória"),

            // Campo auxiliar que controla se a validação deve ocorrer
            hasConnectivityExtraInfo: yup.boolean().default(false),

            // Validação condicional do objeto de info extra
            connectivityExtraInfo: yup
                .object({
                    id: yup.number().nullable(),
                    info: yup.string().nullable(),
                })
                .nullable()
                .when("hasConnectivityExtraInfo", {
                    is: true,
                    then: (schema) =>
                        schema
                            .shape({
                                id: yup.number().required("Selecione uma informação extra"),
                            })
                            .required("A informação extra é obrigatória, selecione uma opção."),
                    otherwise: (schema) => schema.nullable().notRequired(),
                }),
        })
    ),
});